module.exports = __webpack_public_path__ + "img/IMG_9181-224_L_Black.bec44c9a.jpg";